/* istanbul ignore file */
import { array as codecArray, optional as codecOptional } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { JsonPatchAutoTest } from './JsonPatchAutoTest';
const PatchAutoTestDataParser = /* #__PURE__ */ parsers.object([
    ['json', JsonPatchAutoTest],
    ['fixture', /* #__PURE__ */ codecOptional(/* #__PURE__ */ codecArray(parsers.file))],
]);
export class PatchAutoTestData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PatchAutoTestDataParser.decode(input).map(res => new PatchAutoTestData(res));
    }
    static unsafeDecode(input) {
        return PatchAutoTestData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PatchAutoTestDataParser.encode(data);
    }
    static schema() {
        return PatchAutoTestDataParser.schema();
    }
}
